import './App.css';
import Hoofdding from './Hoofdding.js'
import Sound from './Sound.js'


function App() {
  return (
    <div className="App" style ={ { backgroundImage: "url('bg.png')", overflow: 'scroll'}}>
      <Hoofdding />
      <Sound />
    </div>
  );
}

export default App;
